import {Helmet} from "react-helmet";
import { Navbar, Home_uno, Home_dos, Home_tres, Home_cuatro, Home_cinco, Home_seis, Home_siete, Footer } from '../container';
import BotonFlotante from '../components/btnFloat/btnflotante'

//import Sobre from '../components/sobre/Sobre';
//import Libro from '../components/libro/Libro';
//import FooterPrime from '../components/footer1pre/Footer1pre';
//import Ultb from '../components/ultb/Ultb';
import '../App.css';
import { useTranslation } from 'react-i18next';
import LazyLoad from 'react-lazyload';

function Home() {
  const [t, i18n] = useTranslation("home");
  const liga_lang3='/'+i18n.language+"/LibroNegocios";

  return (
    <div className="App">
      <Helmet>
            <title>Sitio oficial de Ricardo Salinas</title>
            {/*<meta name="description" content="En 2008 comencé a compartir mis ideas y puntos de vista sobre diversos temas." />
            <meta property="og:title" content="Sitio oficial de Ricardo Salinas" />
            <meta property="og:description" content="En 2008 comencé a compartir mis ideas y puntos de vista sobre diversos temas." />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://www.ricardosalinas.com/static/media/fotoRS.f8a63f65b159e735a517.png" />
            <meta property="og:url" content="https://www.ricardosalinas.com/" /> */}
        </Helmet>
      <Navbar/> 
      <Home_uno/>
      <Home_cuatro/>
      <Home_dos/>
      <Home_tres/> 
      
      <Home_cinco/>
      <LazyLoad height={450} offset={150}>
      <Home_seis/> 
      </LazyLoad>
      <LazyLoad height={450} offset={150}>
      <Home_siete/>
      </LazyLoad>
      <BotonFlotante/>
      <Footer/>
    </div>
  );
}

export default Home;